// extracted by mini-css-extract-plugin
module.exports = {"date":"printer-report_date_3BlbL","scrollableContent":"printer-report_scrollableContent_3xBNT","scrollableContainer":"printer-report_scrollableContainer_3ytfK"};